<template>
  <div class='bg-gradient-to-b from-pink-100 to-pink-50 min-h-screen flex items-center justify-center'>
    <div v-if='!isAuthorized'>
      <moderator-logout />
    </div>
    <div v-else class='w-full text-xl'>
      <div class='absolute inset-0 p-11'>
        <div class='w-full h-full bg-gray-50 rounded-lg shadow'>
          <div class='flex flex-col items-center h-screen justify-center'>
            <h1 class='flex justify-center p-4 text-2xl'>
            Session Votings
          </h1>
          <div 
            v-if='!hasVotings'
            class='p-6 bg-gray-100 rounded-md hover:bg-pink-200 my-2 w-1/2'>
            <h1 class='text-xl font-medium text-gray-900'>
              There is nothing to vote on available. Please check the Admin page.
            </h1>
          </div>
          <div v-for='sessionVoting in allSessionVotings'
            :key='`session-voting-${sessionVoting.id}`'
            class='p-6 bg-gray-100 rounded-md hover:bg-pink-200 cursor-pointer my-2 w-1/2'
            @click='goToSessionVoting(sessionVoting)'>
            <h1 class='text-xl font-medium text-gray-900'>
              {{sessionVoting.title}}
            </h1>
            <div class='flex flex-row items-center'>
              {{ votingDateFormatted(sessionVoting.scheduledStartTime) }}
              <span
                class='px-4'>
                ({{formattedTimeString(sessionVoting.scheduledStartTime)}} - {{formattedTimeString(sessionVoting.scheduledEndTime)}})
              </span>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ModeratorLogout from '@/views/gbcc2025/ModeratorLogout.vue'
import { mapState, mapGetters, mapActions }  from 'vuex'
import dayjs from 'dayjs'
import utc      from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone' 
dayjs.extend(utc)
dayjs.extend(timezone)

export default {
  name: 'Moderator',
  components: {
    ModeratorLogout,
  },
  computed: {
    ...mapGetters('users', [
      'isAdmin',
      'isModerator',
    ]),
    ...mapState('sessionVoting', [
      'sessionVotingQuestions',
    ]),
    ...mapGetters('sessionVoting', [
      'hasVotingQuestions',
    ]),
    allSessionVotings () {
      let allSessions = []
      for (const sessionVoting of this.sessionVotingQuestions) {
        allSessions = allSessions.concat(sessionVoting.listOfSessions)
      }
      return allSessions
    },
    hasVotings () {
      return this.allSessionVotings.length > 0
    },
    isAuthorized () {
      return this.isAdmin || this.isModerator
    },
  },
  methods: {
    ...mapActions('sessionVoting', [
      'getSessionVotingQuestions',
    ]),
    goToSessionVoting (sessionVoting) {
      this.$router.push({name: 'ModeratorStart', query: {session_id: sessionVoting.id}})
    },
    votingDateFormatted (date) {
      return dayjs(date).tz("Asia/Seoul").format('MMMM DD')
    },
    formattedTimeString (date) {
      return dayjs(date).tz('Asia/Seoul').format('HH:mm')
    },
  },
  mounted () {
    this.$emit('update:layout', 'empty-page')
    this.getSessionVotingQuestions()
  },
  beforeDestroy () {
    this.$emit('update:layout', 'default-layout')
  },
}
</script>
